<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="removegroupdevice"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);"
              class="mx-0 px-2 pb-3 mb-4"
            >
              <h4>Remove Device</h4>
            </div>

            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>

            <div
              class="col-md-8 col-sm-10 text-center mx-auto"
              style="margin-bottom: 40px"
            >
              <h5>Remove this device from the group?</h5>
              <!-- <p>
                This action is irreversible. Are you sure you want to
                permanently delete this record?
              </p> -->
            </div>

            <div
              class="mb-2"
              style="display:flex; justify-content: space-between"
            >
              <button @click="onCancel" type="button" class="btn btn-secondary">
                Cancel
              </button>
              <button @click="confirmremove" class="btn btn-danger">
                Remove Device
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
// import CongratulationsModal from "./CongratulationsModal";

export default {
  name: "RemoveGroupDevice",
  props: {
    show: Boolean,
    removedId: String,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      mssg: "",
      Errormssg: "",

      // congratulationsModal: true,
    };
  },
  components: {
    Loading,
    // CongratulationsModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["deleteGroupDevice", "fetchSingleGroup"]),
    onCancel() {
      this.$emit("closeRemoveGroupDevice");
    },
    confirmremove() {
      this.isLoading = true;
      this.deleteGroupDevice({
        id: this.$route.params.id,
        device: this.removedId,
      })
        .then((res) => {
          this.fetchSingleGroup({ id: this.$route.params.id }).then(() => {
            this.onCancel();
          });
          this.isLoading = false;
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
          setTimeout(() => {
            this.isLoading = true;
          }, 1000);
        })

        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style scoped>
.modal-content {
  overflow-y: inherit;
}
.modal-dialog {
  max-width: 500px !important;
}
.dropdown-toggle {
  border: 1px solid;
}
.device-dropdown {
  position: absolute;
  will-change: transform;
  top: 20px;
  left: -45%;
  transform: translate3d(313px, 35px, 0px);
  max-height: 200px;
  width: 15rem;
  overflow-y: auto;
}
.dropdown-button {
  border-radius: 2px;
}
</style>
